import moment from "moment";

export function appartieneAUtenteMedicina(lavoratore, utente) {
  return (
    Boolean(utente) &&
    (String(lavoratore.UtenteAssociatoCliente) === String(utente) ||
      String(lavoratore.UtenteMedicinaSede) === String(utente))
  );
}

export function scadenzaMedicinaVisibile(
  scadenza,
  dal,
  al,
  mostraTutto,
  oggi = moment(),
) {
  if (mostraTutto || !scadenza) return true;
  const data = moment(scadenza, ["YYYY-MM-DD", moment.ISO_8601], true);
  if (!data.isValid()) return true;
  if (data.isBefore(oggi, "day")) return true;
  if (dal && data.isBefore(moment(dal, "YYYY-MM-DD", true), "day"))
    return false;
  if (al && data.isAfter(moment(al, "YYYY-MM-DD", true), "day")) return false;
  return true;
}
